export default __webpack_public_path__ + "static/media/photography.1f14a0a2.jpeg";